if (!customElements.get('aldeno-deferred-videos')) {
  customElements.define('aldeno-deferred-videos', class extends HTMLElement {
    connectedCallback() {
      this.frames = [...this.querySelectorAll('iframe[data-aldeno-src]')];
      this.update = () => this.frames.forEach(frame => {
        const box = frame.getBoundingClientRect();
        const visible = box.width > 0 && box.height > 0;
        if (!visible) {
          if (frame.hasAttribute('src')) frame.removeAttribute('src');
        } else if (box.top < innerHeight + 200 && box.bottom > -200 && !frame.hasAttribute('src')) {
          frame.src = frame.dataset.aldenoSrc;
        }
      });
      this.observer = new IntersectionObserver(this.update, {rootMargin: '200px'});
      this.frames.forEach(frame => this.observer.observe(frame));
      window.addEventListener('resize', this.update);
      this.update();
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      window.removeEventListener('resize', this.update);
      this.frames?.forEach(frame => frame.removeAttribute('src'));
    }
  });
}
